export default {
  FETCH_PICS: 'FETCH_PICS'
};



// WEBPACK FOOTER //
// ./src/actions/pics/types.js